export const ROUTES = {
  DASHBOARD: '/dashboard',
  FACILITIES: '/facilities',
  SENSORS: '/sensors',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  PRODUCTS: '/products',
  ROLES: '/users-roles',
  BRANCH_MANAGEMENT: '/branch-management',
  PRODUCT_SELECTION: '/product-selection',
  BRANCH_SELECTION: '/branch-selection',
  CHANGE_PASSWORD: '/change-password',
  PROFILE: '/profile',
  BRANCH: '/branch',
  USER_MANAGEMENT: '/user-management',
  ALARMS: '/alarms',
  ALARM_LOG: '/alarms?tab=log',
  ACTIVITY: '/activity',
  GLOBAL_SETTINGS: '/global-settings',
  DOCUMENTS: '/documents',
  REPORTS: '/reports',
  HELP: '/help',
  WHATS_NEW: '/whats-new',
  REPORTS_NEW_SCHEDULE: '/reports/schedule/new',
  REPORTS_EDIT_SCHEDULE: '/reports/schedule/edit/:id',
  KPI: '/kpi',
  REPORTS_SCHEDULE_DETAILS: '/reports/schedule/details/:uuid',
  RESET_PASSWORD: '/reset-password',
  NOT_FOUND: '*',
  NOTIFICATIONS: '/notifications',
  REMINDERS: '/reminders',
}
